document.addEventListener('DOMContentLoaded', () => {
  var productOutputAddButton = $('button.outputs-add-button');
  var musicOptionButtons = $('input[name="music-outputs"]');
  var audioIsPlaying = false;
  var dvdInput = $('input[name=dvd-quantity]');
  var usbInput = $('input[name=usb-quantity]');
  var enhancedContentInput = $('input[name=enhanced-content-quantity]');
  var errorMessageWrapper = $('.product-outputs__error-message-wrapper');
  var productOutputDetails = $('.product-outputs details');

  // Ability to close dropdown on outside click
  $(document).click(function (e) {
    if (!$(e.target).closest('.product-outputs details').length) {
      productOutputDetails.removeAttr('open');
    }
  });

  // Handle max quantity
  dvdInput.change(function (e) {
    var value = $(this).val();
    if (value > 99) {
      $(this).val(99);
      errorMessageWrapper.removeAttr('hidden');
      errorMessageWrapper.find('.product-outputs__error-message').text('Maximum quantity for dvd input is 99');
    } else {
      errorMessageWrapper.attr('hidden', true);
    }
  });

  usbInput.change(function (e) {
    var value = $(this).val();
    if (value > 99) {
      $(this).val(99);
      value = 99
      errorMessageWrapper.removeAttr('hidden');
      errorMessageWrapper.find('.product-outputs__error-message').text('Maximum quantity for usb input is 99');
    } else {
      errorMessageWrapper.attr('hidden', true);
    }

    // attach value added when the value actually changes
    $(this).attr('data-added', value);
  });

  enhancedContentInput.change(function (e) {

    if ($(this).is(':checked')) {
      $(this).attr('data-added', 1);
    } else {
      $(this).attr('data-added', 0);
    }

  });

  // Handle adding outputs
  productOutputAddButton.click(function (e) {
    e.preventDefault();

    const detailsWrapper = e.target.closest('details');
    var contentAdded = '';
    // Handle error message if no value entered
    if (dvdInput.val() == 0 && usbInput.val() == 0 && enhancedContentInput.val() == 0 && e.target.textContent != 'Edit') {
      const errorMessage = 'Please enter a value greater than zero';
      errorMessageWrapper.removeAttr('hidden');
      return errorMessageWrapper.find('.product-outputs__error-message').text(errorMessage);
    }

    //
    if (dvdInput.val() > 0) {
      if (detailsWrapper.querySelector('.dvd-added')) detailsWrapper.querySelector('.dvd-added').remove();
      contentAdded += `<p class="mt-3 dvd-added">You have ${dvdInput.val()} DVDs in your cart.</p>`;
    } else {
      if (detailsWrapper.querySelector('.dvd-added')) detailsWrapper.querySelector('.dvd-added').remove();
    }

    if (usbInput.val() > 0) {
      if (detailsWrapper.querySelector('.usb-added')) detailsWrapper.querySelector('.usb-added').remove();
      contentAdded += `<p class="mt-3 usb-added">You have ${usbInput.val()} USBs in your cart.</p>`;
    } else {
      if (detailsWrapper.querySelector('.usb-added')) detailsWrapper.querySelector('.usb-added').remove();
    }

    if (enhancedContentInput.val() > 0) {
      if (detailsWrapper.querySelector('.enhanced-content-added')) detailsWrapper.querySelector('.enhanced-content-added').remove();
      contentAdded += `<p class="mt-3 usb-added">You have Enhanced Digital Copy in your cart.</p>`;
    } else {
      if (detailsWrapper.querySelector('.enhanced-content-added')) detailsWrapper.querySelector('.enhanced-content-added').remove();
    }

    if (contentAdded.length) {
      e.target.textContent = 'Edit';
      detailsWrapper.querySelector('.summary__title').insertAdjacentHTML('beforeend', contentAdded);
    }
    // Close accordion
    errorMessageWrapper.attr('hidden', true);
    detailsWrapper.removeAttribute('open');
  });

  musicOptionButtons.on('click', function (e) {
    var label = $(`label[for='${e.target.id}']`);
    if (!label?.length) return;
    var audioFile = label.find('audio')[0];
    var pauseIcon = label.find('.icon-pause-wrapper')[0];
    var audioFiles = $('.product-outputs audio');
    audioFiles.each(function (e) {
      var thisFile = $(this)[0];
      if (!thisFile.paused && thisFile != audioFile) {
        thisFile.pause();
        var icon = $('.icon-pause-wrapper.active')[0];
        if (icon) icon.classList.remove('active');
        audioIsPlaying = false;
      }
    });
    if (!audioFile) return;
    if (!audioIsPlaying) {
      audioFile.play();
      pauseIcon.classList.add('active');
      audioIsPlaying = true;
    } else {
      audioFile.pause();
      pauseIcon.classList.remove('active');
      audioIsPlaying = false;
    }
  });
});